<template>
  <div class="chat">
    <div class="balloons">
      <Balloon v-if="done">
        <span
          style="color: #ff6666"
          slot="name"
        >
          Alex
        </span>
        <p slot="message">
          Volgens mij valt er een verjaardag te vieren…
        </p>
      </Balloon>
      <Balloon v-if="showSecond">
        <span
          style="color: #5667C6"
          slot="name"
        >
          Michelle
        </span>
        <p slot="message">
          Jaaaaaa! 🎉
        </p>
      </Balloon>
      <Balloon v-if="showThird">
        <span
          style="color: #525067"
          slot="name"
        >
          Nick
        </span>
        <p slot="message">
          Das waar ook! Borreltijd in de Harmo?? Ga je ook mee?
        </p>
      </Balloon>
      <CorruptBalloon
        @showReply="showReply = true"
        v-if="count > 0"
      >
        <p>Ik kan niet. Mijn kat is ziek.</p>
      </CorruptBalloon>
      <Balloon
        v-if="showReply"
      >
        <span
          style="color: #5667C6"
          slot="name"
        >
          Michelle
        </span>
        <p slot="message">
          Ah joh, een drankje! Die kat kan wel ff alleen blijven ;)
        </p>
      </Balloon>
      <CorruptBalloon
        v-if="count > 1"
      >
        <p>Ja maar heb ook last van m’n rug.</p>
      </CorruptBalloon>
      <ChatForm
        v-if="count < 2 && showThird"
        @formSubmit="formSubmit"
      ></ChatForm>
    </div>
  </div>
</template>

<script>
import Balloon from './Balloon'
import CorruptBalloon from './CorruptBalloon'
import ChatForm from './ChatForm'
import { doneMixin } from '@/mixins'
import { trackChat } from '@/utils/track'

export default {
  name: 'Chat',
  data () {
    return {
      count: 0,
      messageSent: false,
      answer: '',
      showReply: false,
      showSecond: false,
      showThird: false
    }
  },
  components: {
    Balloon,
    CorruptBalloon,
    ChatForm
  },
  mixins: [doneMixin],
  methods: {
    formSubmit () {
      this.messageSent = true
      this.answer = ''
      this.count++

      if (this.count === 1) {
        trackChat('sent-first-reply')
      } else if (this.count === 2) {
        trackChat('sent-second-reply')
      }
    }
  },
  watch: {
    done () {
      setTimeout(() => {
        this.showSecond = true
      }, 2200)
      setTimeout(() => {
        this.showThird = true
      }, 4200)
    }
  }
}
</script>

<style lang="scss" scoped>
.chat {
  padding-top: 65px;
  position: relative;
  padding-bottom: 65px;
  margin-top: 30px;
  background-image: url(~@/assets/images/chat/background.png);
  background-size: 775px 615px;
  background-repeat: repeat;
  background-position: left top;
}
.balloons {
  max-width: 530px;
  margin: 0 auto;
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/Chat.vue